import { PBPListResponse } from '@percent/admin-dashboard/services/pbpResponses'
import { foundationsServiceCapabilities, FoundationType } from './foundations.types'

export const foundationsService = ({ percentClient }: foundationsServiceCapabilities) => ({
  getFoundationsList: () => percentClient.get<PBPListResponse<FoundationType>>('v1/admin/foundations')
})
